import { HIGHLIGHT_STYLE } from 'modules/course/const/styles'

const HIGHLIGHT_STYLE_ID = 'lecture-highlight-style'

export const applyHighlightStylesToIframe = (
  iframe: HTMLIFrameElement | null,
  highlightColor?: string,
) => {
  if (!iframe) return

  const iframeDoc = iframe.contentDocument
  if (!iframeDoc) return

  const iframeRoot = iframeDoc.documentElement
  if (!iframeRoot) return

  if (!highlightColor) return

  iframeRoot.style.setProperty('--color-yellow', highlightColor)

  let styleEl = iframeDoc.getElementById(HIGHLIGHT_STYLE_ID) as HTMLStyleElement | null

  if (!styleEl) {
    styleEl = iframeDoc.createElement('style')
    styleEl.id = HIGHLIGHT_STYLE_ID
    styleEl.textContent = HIGHLIGHT_STYLE
    iframeDoc.head.appendChild(styleEl)
  }
}

export const removeHighlightStylesFromIframe = (iframe: HTMLIFrameElement | null) => {
  if (!iframe) return

  const iframeDoc = iframe.contentDocument
  if (!iframeDoc) return

  iframeDoc.documentElement?.style.removeProperty('--color-yellow')

  const styleEl = iframeDoc.getElementById(HIGHLIGHT_STYLE_ID)

  if (styleEl) {
    styleEl.remove()
  }
}
